<template>
  <label class="e-label" :class="computedClasses">
    <slot /><span class="e-label--required" v-if="required">*</span>
  </label>
</template>
<script>
import themeable from 'vuetify/lib/mixins/themeable'
export default {
  name: 'ELabel',
  mixins: [themeable],
  props: {
    required: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedClasses() {
      return {
        ...this.themeClasses,
      }
    },
  },
}
</script>
